import { get, type Readable } from 'svelte/store';
import { topIslandOptions } from '../components/homepage/top-island';

export default function scrollToLastItemOnLoad(
  scrollableContainer: HTMLElement,
  {
    lastItemContainer,
    arrToWatch,
    startedScrolling
  }: {
    lastItemContainer: Readable<HTMLElement>;
    arrToWatch: Readable<unknown>;
    startedScrolling: Readable<boolean>;
  }
) {

  console.log('scrollToLastItemOnLoad');

  arrToWatch.subscribe(() => {
    const $lastItemContainer = get(lastItemContainer);
    const $startedScrolling = get(startedScrolling);

    if (!$lastItemContainer || !$startedScrolling) {
      return;
    }

    const { top, bottom } = $lastItemContainer.getBoundingClientRect();
    const { innerHeight } = window;

    if (bottom < 0 || top > innerHeight) {
      topIslandOptions.allowAutoDisableScrollVersion = false;

      scrollableContainer.scrollTop = $lastItemContainer.offsetTop;

      requestAnimationFrame(() => {
        topIslandOptions.allowAutoDisableScrollVersion = true;
      });
    }
  });
}
